import { tuiAsPopover } from '@taiga-ui/cdk/services';

import { ConfirmationService } from './confirmation.service';

export const CONFIRMATION_PROVIDER = tuiAsPopover(ConfirmationService);
